import { render, staticRenderFns } from "./review-details-modal.vue?vue&type=template&id=6117d18e"
import script from "./review-details-modal.vue?vue&type=script&lang=js"
export * from "./review-details-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports